<template>
  <v-container>
    <div class="mt-12">
      <v-alert text dense color="deep-orange" icon="mdi-text-search" border="left">
        In order to see products, you need to add conditions to filter, then
        press <strong>Filter products</strong> button. If you want to see all
        products, just press <strong>Filter products</strong> button without any
        conditions added.
      </v-alert>
    </div>
    <div class="mt-12">
      <FilterForm @formatValues="formatFilterValues" :showButtons="true" ref="filterComponent"></FilterForm>
    </div>

    <v-snackbar v-model="snackbarEmpty">
      {{ errorEmpty }}
    </v-snackbar>

    <v-divider class="my-2"></v-divider>

    <v-row>
      <v-col>
        <v-data-table class="mt-6" v-model="selectedProducts" :headers="headers" :items="items" show-select
          item-key="SKU" :single-expand="true" :expanded.sync="expanded" show-expand :search="search" dense
          :options.sync="options" :server-items-length="totalItems" :loading="loading" height="65vh" fixed-header
          :footer-props="{
            'items-per-page-options': [50, 100, 150, 200, 500],
          }">
          <template v-slot:top>
            <v-row class="pb-1">
              <v-col cols="2" v-if="selectedProducts.length > 0">
                <v-btn :loading="loadingExportPiguLt" color="green" outlined @click="exportToPiguLt"><v-icon left>
                    mdi-export-variant </v-icon>
                  Export to pigu.lt
                  <v-icon v-if="exportDone" right>mdi-check-circle</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <!-- First button (Update one by one) -->
              <v-col cols="2" v-if="selectedProducts.length > 0">
                <v-btn color="green" outlined @click="switchStatus"><v-icon left> mdi-export-variant </v-icon>
                  Update Pigu Price
                  <v-icon v-if="exportDone" right>mdi-check-circle</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <!-- Second button (update multiple at once) -->
              <v-col cols="2" v-if="selectedProducts.length > 0">
                <v-btn color="green" outlined @click="switchStatusBulk"><v-icon left> mdi-export-variant </v-icon>
                  Bulk Edit Price
                  <v-icon v-if="exportDone" right>mdi-check-circle</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4" class="pl-0">
                <v-text-field v-model="search" label="Search" class="mx-4" outlined dense
                  hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.Photos`]="{ item }">
            <tr v-for="(itm, p) in item.Photos" :key="p">
              <td v-if="p === 0">
                <v-img max-width="100px" :src="itm"></v-img>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.SKU`]="{ item }">
            <tr>
              <td>
                <span class="font-weight-medium">{{ item.SKU }}</span><br />
                <span v-if="item.Barcode" class="grey--text">
                  BAR: {{ item.Barcode }}
                </span>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.Brand`]="{ item }">
            <tr>
              <td>
                <span>{{ item.Brand }}</span><br />
                <span class="grey--text"> Currency: {{ item.Currency }} </span>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.stock`]="{ item }">
            <v-chip small :color="item.stock < 1 ? 'grey' : 'green'" dark>
              {{ item.stock }}
            </v-chip>
          </template>
          <!-- <template v-slot:[`item.platforms`]="{ item }">
            <v-menu>
              <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <span
                      class="blue--text font-weight-medium"
                      v-bind="attrs"
                      v-on="{ ...tooltip, ...menu }"
                      >Rules</span
                    >
                  </template>
                </v-tooltip>
              </template>
            </v-menu>
          </template> -->
          <template v-slot:[`item.Brand`]="{ item }">
            <tr>
              <td>
                <span>{{ item.Brand }}</span><br />
                <span class="grey--text"> Currency: {{ item.Currency }} </span>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.stock`]="{ item }">
            <v-chip small :color="item.stock < 1 ? 'grey' : 'green'" dark>
              {{ item.stock }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="40" @click="openHistory(item)"
                  color="accent">mdi-eye-circle</v-icon>
              </template>
              <span>View product history</span>
            </v-tooltip>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <ProductInfo :product="item"></ProductInfo>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="PiguLtExportDone" width="500px">
      <v-card>
        <v-card-title class="footer basic--text"> XML link </v-card-title>
        <v-card-text>
          <v-row justify="center" class="mt-5">
            <v-col cols="9">
              <p>{{ xmlLink }}</p>
            </v-col>
            <v-col cols="3">
              <v-btn outlined color="success" @click="copyToClipboard">Copy</v-btn>
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-5">
            <p>
              this link will be always available only for the last chosen
              products
            </p>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showUpdatePrice" width="800px">
      <v-card>
        <v-card-title class="footer basic--text">
          Update Products Prices
        </v-card-title>
        <v-card-text>
          <v-row justify="center" class="mt-5 price-item" v-for="(item, index) in SKUForUpdate" :key="index"
            align="center">
            <v-col cols="4">
              <p>SKU : {{ item.SKU }}</p>
              <p>Brand : {{ item.Brand }}</p>
              <v-img max-width="100px" v-if="item.image" :src="item.image"></v-img>
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col cols="12">
                  <v-text-field outlined dense label="RRP" color="primary" type="text" :rules="[rules.prices]"
                    v-model="item.RRP" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field outlined dense label="Pigu Price" color="primary" type="text" v-model="item.PiguPrice"
                    :rules="[rules.prices]" hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="update_button">
            <v-col cols="8" class="alert_price">
              <v-alert v-if="ErrorInPrices" text dense color="deep-orange" icon="mdi-text-search" border="left">
                Please fix the errors in the prices
              </v-alert>
            </v-col>
            <v-col cols="4" class="buttons">
              <v-btn class="update_btn" @click="cancel">Cancel </v-btn>
              <v-btn color="success" class="update_btn" @click="updatePrices">Update
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="BulkModal" width="800px">
      <v-card>
        <v-card-title class="footer basic--text">
          Update Multiple Products Prices
        </v-card-title>
        <v-card-text>
          <v-row justify="center" class="mt-5" align="center">
            <v-col cols="12">
              <v-text-field outlined dense label="RRP" color="primary" type="text" :rules="[rules.pricesBulk]"
                v-model="blukPrices.RRP" hide-details="auto"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field outlined dense label="Pigu Price" color="primary" type="text" v-model="blukPrices.PiguPrice"
                :rules="[rules.pricesBulk]" hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="update_button">
            <v-col cols="8" class="alert_price">
              <v-alert v-if="ErrorInPrices" text dense color="deep-orange" icon="mdi-text-search" border="left">
                Please fix the errors in the prices ! At least one price should
                be updated !
              </v-alert>
            </v-col>
            <v-col cols="4" class="buttons">
              <v-btn class="update_btn" @click="cancel">Cancel </v-btn>
              <v-btn color="success" class="update_btn" @click="updatePrices">Update
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="ShowUpdatingStatus" width="unset">
      <status-info :responseMessage="responseMessage" :filename="filename" :pending="pending" @close="closeStatuDialog"
        :showCheckBtn="false"></status-info>
    </v-dialog>
    <ProductHistoryDialog :product="productForHistory" ref="productHistoryDialog"></ProductHistoryDialog>
  </v-container>
</template>

<script>
import FilterForm from "@/components/organisms/FilterForm.vue";
import ProductInfo from "../organisms/ProductInfo.vue";
import ProductHistoryDialog from "../Descriptions/ProductHistoryDialog.vue";
import StatusInfo from "../organisms/StatusInfo";

export default {
  name: "NotExportedToPiguLt",
  props: {},
  components: {
    StatusInfo,

    FilterForm,
    ProductInfo,
    ProductHistoryDialog,
  },
  data: () => ({
    snackbarEmpty: false,
    errorEmpty: `Please select products to export.`,
    selectedProducts: [],
    loadingExport: false,
    loadingExportPiguLt: false,
    exportDone: false,
    PiguLtExportDone: false,
    loadingFlashSales: false,
    flashSalesDone: false,
    xmlLink: "",
    headers: [
      { text: "PLATFORMS", value: "platforms", class: "footer" },
      { text: "PHOTO", value: "Photos", class: "footer" },
      { text: "SKU", value: "SKU", class: "footer" },
      { text: "BARCODE", value: "Barcode", class: "footer" },
      { text: "CATEGORY", value: "Category", class: "footer" },
      { text: "CONDITION", value: "Condition", class: "footer" },
      { text: "BRAND", value: "Brand", class: "footer" },
      { text: "RRP", value: "RRP", class: "footer" },
      { text: "PIGU PRICE", value: "PiguPrice", class: "footer" },
      { text: "STOCK", value: "stock", class: "footer" },
      { text: "HISTORY", value: "actions", class: "footer" },
    ],
    items: [],
    expanded: [],
    search: "",
    loadingFilter: false,
    fileName: "",
    downloadPopup: false,
    platform: "",
    platforms: [
      {
        platform: "ebay.fr",
        language: "French",
        code: "fr",
      },
      {
        platform: "ebay.it",
        language: "Italian",
        code: "it",
      },
      {
        platform: "ebay.de",
        language: "German",
        code: "de",
      },
      {
        platform: "ebay.es",
        language: "Spanish",
        code: "es",
      },
      {
        platform: "ebay.co.uk",
        language: "English",
        code: "en",
      },
      {
        platform: "ebay.com",
        language: "English",
        code: "en",
      },
      {
        platform: "ebay.au",
        language: "English",
        code: "en",
      },
      {
        platform: "bcf.lt",
        language: "Lithuanian",
        code: "lt",
      },
      {
        platform: "bcfashion.com",
        language: "English",
        code: "en",
      },
    ],
    platformSelected: false,
    productForHistory: {},
    showUpdatePrice: false,
    SKUForUpdate: [],
    ShowUpdatingStatus: false,
    filename: "",
    pending: false,
    responseMessage: "",
    ErrorInPrices: false,
    BulkModal: false,
    blukPrices: {
      RRP: "",
      PiguPrice: "",
    },
    rules: {
      prices: (value) => {
        if (value <= 0 || isNaN(value) || value.length < 1) {
          return "Amount must be more than 0 and must be a price !";
        } else {
          return true;
        }
      },
      pricesBulk: (value) => {
        if (value <= 0 || isNaN(value)) {
          return "Amount must be more than 0 and must be a price !";
        } else {
          return true;
        }
      },
    },
    // NEW PROPERTIES FOR PAGINATION
    options: {},
    totalItems: 0,
    currentFilters: [],
    loading: false,
  }),
  watch: {
    items(val) {
      if (val.length == 0) {
        this.loadingFilter;
      }
    },
    // NEW WATCHER FOR PAGINATION
    options: {
      handler() {
        if (this.currentFilters.length > 0) {
          this.filterProducts(this.currentFilters);
        }
      },
      deep: true,
    },
  },
  async mounted() { },
  methods: {
    cancel() {
      this.blukPrices = {
        RRP: "",
        PiguPrice: "",
      };
      this.ErrorInPrices = false;
      this.BulkModal = false;
      this.ShowUpdatingStatus = false;
      this.showUpdatePrice = false;
    },
    switchStatusBulk() {
      this.blukPrices = {
        RRP: "",
        PiguPrice: "",
      };
      this.BulkModal = true;
      this.ErrorInPrices = false;
      var newProducts = [];
      this.selectedProducts.map((item) => {
        var newProduct = {
          SKU: item.SKU,
          RRP: item.RRP,
          PiguPrice: item.PiguPrice ? item.PiguPrice : null,
          image: item.Photos && item.Photos.length > 0 ? item.Photos[0] : null,
          Brand: item.Brand,
        };
        newProducts.push(newProduct);
      });
      this.SKUForUpdate = newProducts;
    },
    closeStatuDialog() {
      this.ShowUpdatingStatus = false;
      this.BulkModal = false;
      this.ErrorInPrices = false;
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.xmlLink);
      this.PiguLtExportDone = false;
    },
    async updatePrices() {
      // TODO ? updated the pricing of the products !
      if (this.BulkModal) {
        console.log(
          "this is SKUForUpdate ==>",
          JSON.stringify(this.SKUForUpdate)
        );
        var newPrices = [];
        newPrices = this.SKUForUpdate.map((item) => {
          return {
            SKU: item.SKU,
            RRP:
              this.blukPrices.RRP != null &&
                this.blukPrices.RRP.length &&
                this.blukPrices.RRP.length > 0 &&
                !isNaN(this.blukPrices.RRP) &&
                this.blukPrices.RRP > 0
                ? this.blukPrices.RRP
                : item.RRP,
            PiguPrice:
              this.blukPrices.PiguPrice != null &&
                this.blukPrices.PiguPrice.length &&
                this.blukPrices.PiguPrice.length > 0 &&
                !isNaN(this.blukPrices.PiguPrice) &&
                this.blukPrices.PiguPrice > 0
                ? this.blukPrices.PiguPrice
                : item.PiguPrice,
          };
        });
        this.SKUForUpdate = newPrices;
      }
      if (!this.BulkModal) {
        for (var i = 0; i < this.SKUForUpdate.length; i++) {
          if (
            this.SKUForUpdate[i].RRP <= 0 ||
            this.SKUForUpdate[i].PiguPrice <= 0 ||
            isNaN(this.SKUForUpdate[i].RRP) ||
            isNaN(this.SKUForUpdate[i].PiguPrice) ||
            !this.SKUForUpdate[i].RRP ||
            !this.SKUForUpdate[i].PiguPrice ||
            this.SKUForUpdate[i].RRP.length == 0 ||
            this.SKUForUpdate[i].PiguPrice.length == 0
          ) {
            this.ErrorInPrices = true;
            console.log(i);
            break;
          } else {
            this.ErrorInPrices = false;
          }
        }
      } else {
        var RRPCondition =
          this.blukPrices.RRP == null ||
          isNaN(this.blukPrices.RRP) ||
          !this.blukPrices.RRP ||
          this.blukPrices.RRP <= 0;
        var PiguPriceCondition =
          this.blukPrices.PiguPrice == null ||
          isNaN(this.blukPrices.PiguPrice) ||
          !this.blukPrices.PiguPrice ||
          this.blukPrices.PiguPrice <= 0;
        var both =
          this.blukPrices.RRP != null &&
          this.blukPrices.RRP.length > 0 &&
          (isNaN(this.blukPrices.RRP) ||
            !this.blukPrices.RRP ||
            this.blukPrices.RRP <= 0);
        var both2 =
          this.blukPrices.PiguPrice != null &&
          this.blukPrices.PiguPrice.length > 0 &&
          (isNaN(this.blukPrices.PiguPrice) ||
            !this.blukPrices.PiguPrice ||
            this.blukPrices.PiguPrice <= 0);
        if (
          (RRPCondition && PiguPriceCondition) ||
          both ||
          both2 ||
          (!this.blukPrices.RRP.length && !this.blukPrices.PiguPrice.length)
        ) {
          this.ErrorInPrices = true;
        } else {
          this.ErrorInPrices = false;
        }
      }

      if (this.ErrorInPrices) {
        return;
      }
      this.pending = true;
      this.ShowUpdatingStatus = true;
      this.showUpdatePrice = false;
      this.BulkModal = false;
      this.filename = "loading.svg";
      console.log(
        "this is SKUForUpdate ==>",
        JSON.stringify(this.SKUForUpdate)
      );
      this.$store
        .dispatch("updatePrices", this.SKUForUpdate)
        .then(() => {
          this.responseMessage = "Product Prices has been updated !";
          this.filename = "done.png";
          this.pending = false;
          var newItems = [];
          this.selectedProducts.map((item) => {
            var currentItem = this.SKUForUpdate.find((i) => i.SKU == item.SKU);
            if (!currentItem) {
              newItems.push(item);
            } else {
              newItems.push({
                ...item,
                RRP: currentItem.RRP,
                PiguPrice: currentItem.PiguPrice,
              });
            }
          });
          this.selectedProducts = newItems;
          newItems = [];
          this.items.map((item) => {
            var currentItem = this.SKUForUpdate.find((i) => i.SKU == item.SKU);
            if (!currentItem) {
              newItems.push(item);
            } else {
              newItems.push({
                ...item,
                RRP: currentItem.RRP,
                PiguPrice: currentItem.PiguPrice,
              });
            }
          });
          this.items = newItems;
        })
        .catch(() => {
          this.responseMessage =
            "Something went wrong ! Please contact your tech support !";
          this.filename = "server_down.png";
          this.pending = false;
        });

      setTimeout(() => { }, 2000);
    },
    switchStatus() {
      this.showUpdatePrice = true;
      this.ErrorInPrices = false;
      var newProducts = [];
      this.selectedProducts.map((item) => {
        var newProduct = {
          SKU: item.SKU,
          RRP: item.RRP,
          PiguPrice: item.PiguPrice ? item.PiguPrice : null,
          image: item.Photos && item.Photos.length > 0 ? item.Photos[0] : null,
          Brand: item.Brand,
        };
        newProducts.push(newProduct);
      });
      this.SKUForUpdate = newProducts;
    },
    exportToPiguLt() {
      let SKUArray = [];
      if (this.selectedProducts.length == 0) {
        this.snackbarEmpty = true;
      } else {
        this.loadingExportPiguLt = true;
        this.exportDone = false;
        for (let item of this.selectedProducts) {
          SKUArray.push(item.SKU);
        }
        var promise = new Promise((resolve) => {
          localStorage.setItem("skus-pigult", JSON.stringify(SKUArray));
          resolve();
        });
        promise.then(() => this.$router.push("/export/pigult"));
      }
    },
    openHistory(item) {
      this.productForHistory = item;
      this.$refs.productHistoryDialog.showDialog(item);
    },
    formatFilterValues(filters) {
      this.items = [];
      let finalData = [];
      let val = "";
      this.$refs.filterComponent.setLoading(true);

      finalData.push(["ExportState", "equals", "Not Exported"]);
      finalData.push(["Described", "equals", true]);

      if (filters.length > 0) {
        for (let obj of filters) {
          if (obj.condition == "Yes") {
            val = true;
          } else if (obj.condition == "No") {
            val = false;
          } else if (obj.property["type"] === "Number") {
            val = parseInt(obj.value);
          } else if (obj.property["type"] === "Array") {
            val = obj.value;
          } else {
            val = obj.value;
          }
          finalData.push([obj.property["name"], obj.condition, val]);
        }
      }

      // NEW: Store filters for pagination
      this.currentFilters = finalData;
      this.filterProducts(finalData);
    },
    filterProducts(data) {
      // NEW: Get pagination params
      const { page, itemsPerPage } = this.options;

      // NEW: Set loading state
      this.loading = true;

      this.$store
        .dispatch("filterProductsPiguLt", {
          filters: data,
          page: page || 1,
          limit: itemsPerPage || 100
        })
        .then((response) => {
          // NEW: Handle new response format
          if (response.data.data) {
            this.items = response.data.data;
            this.totalItems = response.data.pagination?.total || response.data.data.length;
          } else {
            // Fallback for old format
            this.items = response.data;
            this.totalItems = response.data.length;
          }

          this.selectedProducts = [];
          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
        })
        .catch((error) => {
          console.log("this is the error message ==> ", error.response.data);
          this.loading = false;
          this.$refs.filterComponent.setLoading(false);
          let errorMsg = "";
          errorMsg = error.response.data
            ? error.response.data
            : "Something went wrong while filtering.";

          this.$refs.filterComponent.setLoadingFailed(true, errorMsg);
          console.log(error);
        });
    },
  },
};
</script>
<style>
.update_button {
  display: flex;
  justify-content: flex-end;
}

.update_btn {
  margin: 1em;
}

.price-item {
  padding-bottom: 1em;
  border-bottom: 1px solid lightgray;
}

.alert_price {
  display: flex !important;
  align-items: center !important;
}

.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
